import classNames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { showBiomeDetails } from '~app/actions/biomeDetails';
import { addFavorite, removeFavorite, isFavoriteLocationInfo } from '~app/actions/favorites';
import { clearPins, clearSearchTerm, clearSelection, enterCompareMode, SelectionMode } from '~app/actions/search';

import defined from '~app/core/defined';

import BiomeSummary from './BiomeSummary';
import BiomeSummaryLoading from './BiomeSummaryLoading';
import CloseButton from './CloseButton';

class BiomePanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      locationInfo: props.locationInfo,
    };

    // Bind this function only once so that add/removeEventListener are
    // dealing with the same function.
    this._onHideComplete = ::this.onHideComplete;
  }

  hide() {
    this.props.clearSelection();
    this.props.clearPins();
    this.props.clearSearchTerm();
  }

  componentWillReceiveProps(nextProps) {

    if (defined(this.props.location) &&
        !defined(nextProps.location)) {
      // We are going from full to empty. We want to keep the state.location
      // around until the outro animation is complete so that we can continue
      // to display the content until the panel is off screen.
      this.addHideCompletionHandler();
    }
    else if (defined(nextProps.locationInfo)) {
      // Otherwise, we are going from empty to full or full to full,
      // so set the state.locationInfo to allow the new content to be displayed.
      this.setState({
        locationInfo: nextProps.locationInfo,
      });
      // Also make sure we clear the completion handler.
      // This catches the case where the user has a location visible, clears it,
      // and manages to select a new location during the outro animation.
      // In this case, we no longer want to clear the location at the end
      // of the transition because we are now dealing with an intro transition,
      // not an outro transition.
      this.removeHideCompletionHandler();
    }
  }

  onHideComplete(event) {
    this.setState({
      locationInfo: null,
    });
    this.removeHideCompletionHandler();
  }

  addHideCompletionHandler() {
    this.panel.addEventListener("transitionend", this._onHideComplete);
  }
  removeHideCompletionHandler() {
    this.panel.removeEventListener("transitionend", this._onHideComplete);
  }

  onInfoButtonPressed() {
    this.props.showBiomeDetails(this.props.locationInfo);
    this.hide();
  }

  onCompareButtonPressed() {
    this.props.enterCompareMode(SelectionMode.compareRight);
  }

  onSaveButtonPressed() {
    if (this.props.isFavorite) {
      this.props.removeFavorite(this.props.locationInfo);
    }
    else {
      this.props.addFavorite(this.props.locationInfo);
    }
  }

  shouldShowPanel() {
    return defined(this.props.location) &&
      this.props.selectionMode === SelectionMode.select;
  }

  shouldShowSummary() {
    return defined(this.state.locationInfo);
  }

  renderSummary() {
    if (this.shouldShowSummary()) {
      return (
        <BiomeSummary
          locationInfo={this.state.locationInfo}
          isFavorite={this.props.isFavorite}
          isBusy={this.props.isBusy}
          onInfoButtonPressed={::this.onInfoButtonPressed}
          onCompareButtonPressed={::this.onCompareButtonPressed}
          onSaveButtonPressed={::this.onSaveButtonPressed}
        />
      );
    }
  }

  shouldShowLoading() {
    return !defined(this.state.locationInfo) ||
      (defined(this.props.location) &&
       !this.state.locationInfo.location.equals(this.props.location));
  }

  renderLoading() {
    if (this.shouldShowLoading()) {
      return (
        <BiomeSummaryLoading />
      );
    }
  }

  render() {
    // There is a subtlety here.
    // Trigger the --hidden css class on *props*.locationInfo,
    // but determine whether to show the content based on *state*.locationInfo.
    //
    // The props are tracking the data in the store, which tells us when
    // to start our animated transitions.
    //
    // We keep a copy of the content in our state so that we can continue
    // to display the contents during the outro-animation.
    return (
      <div className={classNames("BiomePanel", {
                                 "BiomePanel--hidden": !this.shouldShowPanel(),
                               })}
          ref={(elem) => this.panel = elem}
      >
        {this.renderSummary()}
        {this.renderLoading()}
        <CloseButton
          onClick={::this.hide}
        />
      </div>
    );
  }
}

BiomeSummary.propTypes = {
  locationInfo: PropTypes.object,
  isBusy: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  location: state.search.selectedLocation,
  locationInfo: state.search.selectedLocationInfo,
  selectionMode: state.search.selectionMode,
  isFavorite: isFavoriteLocationInfo(state.search.selectedLocationInfo, state.favorites.locationInfos),
  isBusy: state.busy.isBusy,
});

const mapDispatchToProps = {
  clearSelection,
  clearPins,
  clearSearchTerm,
  addFavorite,
  removeFavorite,
  showBiomeDetails,
  enterCompareMode,
};

export { BiomePanel };
export default connect(mapStateToProps, mapDispatchToProps)(BiomePanel);



// WEBPACK FOOTER //
// ./src/components/BiomePanel.js